import { defineComponent as _defineComponent } from 'vue'
import {Proposal} from "@/models/store/proposal";
import MarkdownRender from "@/components/commons/MarkdownRender.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProposalDescription',
  props: {
    proposal: { type: Object, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props;

const getDescription = () => {
  if(props.proposal?.content?.description)
    return props.proposal.content.description;
  else if(props.proposal?.metaData)
    try {
      return JSON.parse(props.proposal.metaData).description;
    } catch(e) {
      console.log(e);
      return '';
    }

};


const __returned__ = { props, getDescription, MarkdownRender }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})